import * as React from 'react';
import { Modal, Button } from "react-bootstrap";
import { connect } from 'react-redux';
import * as actionCreator from '../../actions/actions';
import { Dispatch } from 'redux';
import * as moment from 'moment';
import '../css/ModernPopups.css';

interface State {
}

interface Props {
    selectedFlat: any,
    token: any,
    show: boolean,
    doorLogList: Array<any>,
    hide(error: string): void,
    getDoorLogsByFlat(token: any, flatId: any): void;
}

const mapStateToProps = (state: any) => {
    return {
        doorLogList: state.doorLogList,
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        getDoorLogsByFlat: (token: any, flatId: any) => dispatch<any>(actionCreator.default.smartHouse.getDoorLogsByFlat(token, flatId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(class SmartHouseDoorLogPopup extends React.Component<Props, State> {

    componentDidUpdate(prevProps: Props) {
        // Fetch logs each time the popup is opened for a flat
        if (this.props.show && !prevProps.show && this.props.selectedFlat && this.props.selectedFlat.flatId) {
            this.props.getDoorLogsByFlat(this.props.token, this.props.selectedFlat.flatId);
        }
    }

    render() {
        const logs = this.props.doorLogList || [];

        const displayLogs = logs.map((item, index) => (
            <tr key={index} className="table-row">
                <td>
                    <span className="date-text">
                        {item.timestamp ? moment.parseZone(item.timestamp).format('DD/MM/YYYY HH:mm:ss') : "N/A"}
                    </span>
                </td>
                <td>
                    <span className={`door-status-label ${item.isOpen ? 'open' : 'closed'}`}>
                        <i className={`fas ${item.isOpen ? 'fa-unlock' : 'fa-lock'} me-1`}></i>
                        {item.isOpen ? 'Opened' : 'Closed'}
                    </span>
                </td>
                <td>{item.source || "N/A"}</td>
                <td>
                    <span className="badge bg-info">{item.key?.keyDescription || item.method || "N/A"}</span>
                </td>
            </tr>
        ));

        return (
            <Modal
                show={this.props.show}
                onHide={() => this.props.hide("")}
                className="modern-modal"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-clock-rotate-left me-2"></i>
                        Door Activity{this.props.selectedFlat?.flatName ? ` - ${this.props.selectedFlat.flatName}` : ''}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="table-responsive">
                        <table className="table table-modern table-compact">
                            <thead>
                                <tr>
                                    <th scope="col"><i className="fas fa-calendar me-2"></i>When</th>
                                    <th scope="col"><i className="fas fa-door-open me-2"></i>Action</th>
                                    <th scope="col"><i className="fas fa-user me-2"></i>For</th>
                                    <th scope="col"><i className="fas fa-key me-2"></i>Key</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayLogs}
                            </tbody>
                        </table>
                        {logs.length === 0 && (
                            <p className="text-center text-muted my-3">No activity recorded yet.</p>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.hide("")}>
                        <i className="fas fa-times me-2"></i>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
})
